<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Progress Report</title>
    <link rel="icon" href="../../../../assets/image/favicon.ico" type="image/icon" sizes="16x16">
    <!-- Bootstrap -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css"
        integrity="sha384-TX8t27EcRE3e/ihU7zmQxVncDAy5uIKz4rEkgIXeMed4M0jlfIDPvg6uqKI2xXr2" crossorigin="anonymous">

    <script th:src="@{/progressReport/js/main.js}" type="text/javascript"></script>
    <!-- font awesome -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <!-- font style -->
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700&display=swap"
        rel="stylesheet">
    <!-- jQuery -->

    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.8.0/html2pdf.bundle.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>



    <!-- <script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js"
            integrity="sha384-9/reFTGAW83EW2RDu2S0VKaIzap3H66lZH81PoYlFhbGU+6BZp6G7niu735Sk7lN"
            crossorigin="anonymous"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/js/bootstrap.min.js"
            integrity="sha384-w1Q4orYjBQndcko6MimVbzY0tgp4pWB4lZ7lr30WKz0vr/aWKhXdBNmNb5D92v7s"
            crossorigin="anonymous"></script> -->






    print pdf scripts starts
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.8.0/html2pdf.bundle.min.js"></script>


    <script src="https://code.highcharts.com/stock/highstock.js"></script>
    <script src="https://code.highcharts.com/stock/modules/data.js"></script>
    <script src="https://code.highcharts.com/stock/modules/exporting.js"></script>
    <script src="https://code.highcharts.com/stock/modules/export-data.js"></script>
    <script src="https://code.highcharts.com/stock/modules/accessibility.js"></script>


    <style>
        div.page {
            page-break-after: always;
            page-break-inside: avoid;
        }
    </style>

</head>

<body>
    <input type="hidden" id="jwTokenId" [value]="jwt">
    <input type="hidden" id="admNoId" [value]="admNo">
    <input type="hidden" id="scaistWebServiceBaseURLId" [value]="scaitsWebServiceUrl">

    <div id="loadingImgDiv" align="center" style="margin-top: 10%; display: none;">
        <img src="https://d3pmsauftmmptf.cloudfront.net/assets/media/global/img/loadingImage.gif" alt="Loading">
    </div>
    <div id="dvProgressReportContainerId">
        <section class="academic_area">
            <div class="container" id="dvMainProgressReportId">
                <div class="row">
                    <div class="col-md-6 col-lg-6 col-6 tabs">
                        <div id="tab1">
                            <button class="pro_title tabbutton" id="button1" (click)="changetab('tab1')">Overall Progress
                                Report</button>
                        </div>
                        <div id="tab2">
                            <button class="pro_title tabbutton" id="button2" (click)=" changetab('tab2')">All Test
                                Results</button>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-6">
                        <button id="btnDownloadPDFId" type="button" class="report_btn" data-toggle="modal"
                            data-target="#enrollnow">Download Report Card</button>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-12 col-12">
                        <div class="row mb_30" id="detailsContainer">


                            <div id="allTestResults">
                                <div class="col-md-2">
                                    <button id="btnTestCode_TestTypeListId2" type="button"
                                        class="testtype_btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        {{btnTestCode_TestTypeList2}}
                                    </button>
                                    <div class="dropdown-menu" id="dvTestCode_TestTypeListId"
                                        aria-labelledby="btnGroupDrop1">
                                        <button class="dropdown-item" *ngFor="let testType of testTypeList"
                                            (click)="allTestResults(testType.testType)">
                                            {{ testType.testType }}
                                        </button>
                                    </div>
                                </div>
                                <div id="allTestResultsTable" class="" *ngIf="showTable">
                                    <app-progress-repot-table [parentData]="dataToSend"></app-progress-repot-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="progressReport">
                    <div class="row mb_30">
                        <div class="col-md-6">
                            <div class="report_card">
                                <div class="white_card_header">
                                    <div class="mod_flex">
                                        <div>
                                            <h2 class="main_title">
                                                <!-- <span class="neetbg" id="testModeId1" ></span>  -->
                                                <span style='font-size:16px' id="testTypeId1"></span>
                                                <br><span style='font-size:12px' id="testNameId1"></span>
                                            </h2>
                                        </div>
                                        <div class="col-md-2">
                                            <!-- <button id="btnRank_TestTypeListId" class="testtype_btn dropdown-toggle" ngbDropdownToggle>
                                       {{btnRank_TestTypeList}}
                                      </button>
                                      <div ngbDropdownMenu id="dvRank_TestTypeListId" aria-labelledby="btnGroupDrop1">
                                        <button class="dropdown-item" *ngFor="let testType of testTypeList" (click)="onTestTypeClick(testType.testType, 'rank')">
                                          {{ testType.testType }}
                                        </button>
                                      </div> -->
                                            <button id="btnRank_TestTypeListId" type="button"
                                                class="testtype_btn dropdown-toggle" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                {{btnRank_TestTypeList}}
                                            </button>
                                            <div class="dropdown-menu" id="dvRank_TestTypeListId"
                                                aria-labelledby="btnGroupDrop1">
                                                <button class="dropdown-item" *ngFor="let testType of testTypeList"
                                                    (click)="onTestTypeClick(testType.testType, 'rank')">
                                                    {{ testType.testType }}
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="white_card_header">
                                    <div class="rankflex mb_20">
                                        <div class="br_flex">
                                            <div>
                                                <figure class="mb-0">
                                                    <img src="../../../../assets/image/cup.png" alt="cup" class="rpcup">
                                                </figure>
                                            </div>
                                            <div>
                                                <h6 class="rank_title">Branch Rank</h6>
                                                <h2 class="rank_num" id="campusRankId"></h2>
                                            </div>
                                        </div>
                                        <div class="st_flex">
                                            <div>
                                                <figure class="mb-0">
                                                    <img src="../../../../assets/image/cup.png" alt="cup" class="rpcup">
                                                </figure>
                                            </div>
                                            <div>
                                                <h6 class="rank_title">State Rank</h6>
                                                <h2 class="rank_num" id="stateRankId"></h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="rankflex">
                                        <div class="air_flex">
                                            <div>
                                                <figure class="mb-0">
                                                    <img src="../../../../assets/image/cup.png" alt="cup" class="rpcup">
                                                </figure>
                                            </div>
                                            <div>
                                                <h6 class="rank_title">AIR</h6>
                                                <h2 class="rank_num" id="airRankId"></h2>
                                            </div>
                                        </div>
                                        <div class="airpr_flex">
                                            <div>
                                                <figure class="mb-0">
                                                    <img src="../../../../assets/image/cup.png" alt="cup" class="rpcup">
                                                </figure>
                                            </div>
                                            <div>
                                                <h6 class="rank_title">AIR Projected Rank</h6>
                                                <h2 class="rank_bignum" id="projectedRankId"></h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="report_card">
                                <div class="white_card_header">
                                    <div class="mod_flex">
                                        <div>
                                            <h2 class="main_title">
                                                <!-- <span class="neetbg" id="testTypeId2" > </span> -->
                                                Recent Exam - Subject Wise Performance
                                                <br><span style='font-size:12px' id="testNameId2">

                                                </span>
                                            </h2>
                                        </div>
                                        <div class="col-md-2">
                                            <button id="btnSubjectPerformance_TestTypeListId" type="button"
                                                class="testtype_btn dropdown-toggle" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                {{btnSubjectPerformance_TestTypeList}}
                                            </button>
                                            <div class="dropdown-menu" id="dvSubjectPerformance_TestTypeListId"
                                                aria-labelledby="btnGroupDrop1">
                                                <button class="dropdown-item" *ngFor="let testType of testTypeList"
                                                    (click)="onTestTypeClick(testType.testType, 'subjectPerformance')">
                                                    {{ testType.testType }}
                                                </button>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <div class="white_card_header">
                                    <div id="chartSubjectWisePerformanceId" style="height: 280px; width: 100%;"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb_30">
                        <div class="col-md-6">
                            <div class="report_card">
                                <div class="white_card_header">
                                    <div class="mod_flex">
                                        <div>
                                            <h4 class="main_title"> <span class="neetbg" id="testTypeId3"></span> Test
                                                Mode Wise Performance</h4>
                                        </div>
                                        <div class="col-md-2">
                                            <button id="btnTestMode_TestTypeListId" type="button"
                                                class="testtype_btn dropdown-toggle" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                {{btnTestMode_TestTypeList}}
                                            </button>
                                            <div class="dropdown-menu" id="dvTestMode_TestTypeListId"
                                                aria-labelledby="btnGroupDrop1">
                                                <button class="dropdown-item" *ngFor="let testType of testTypeList"
                                                    (click)="onTestTypeClick(testType.testType, 'testMode')">
                                                    {{ testType.testType }}
                                                </button>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div class="white_card_header">
                                    <div id="chartContainerTestModeId" style="height: 270px; width: 100%;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="report_card">
                                <div class="white_card_header">
                                    <div class="mod_flex">
                                        <div>
                                            <h4 class="main_title"><span class="neetbg" id="testTypeId4"></span> Exam
                                                Wise Performance</h4>
                                        </div>
                                        <div class="col-md-2">

                                            <button id="btnExamPerformance_TestTypeListId" type="button"
                                                class="testtype_btn dropdown-toggle" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                {{btnExamPerformance_TestTypeList}}
                                            </button>
                                            <div class="dropdown-menu" id="dvExamPerformance_TestTypeListId"
                                                aria-labelledby="btnGroupDrop1">
                                                <button class="dropdown-item" *ngFor="let testType of testTypeList"
                                                    (click)="onTestTypeClick(testType.testType, 'examPerformance')">
                                                    {{ testType.testType }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="white_card_header">
                                    <div id="container" style="height: 270px; width: 100%;"></div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row col-md-6 col-lg-6 col-8">
                        <h4 class="main_title"><span class="neetbg" id="testTypeId5"></span> Exam Wise Performance</h4>

                    </div>

                    <br>
                    <div class="row mb_30" id="detailsContainer">

                        <div class="col-md-2">
                            <button id="btnTestCode_TestTypeListId" type="button" class="testtype_btn dropdown-toggle"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{btnTestCode_TestTypeList}}
                            </button>
                            <div class="dropdown-menu" id="dvTestCode_TestTypeListId" aria-labelledby="btnGroupDrop1">
                                <button class="dropdown-item" *ngFor="let testType of testTypeList "
                                    (click)="onTestTypeClick(testType.testType, 'testCode')">
                                    {{ testType.testType }}
                                </button>
                            </div>
                        </div>
                        <div class="col-md-10">
                            <select id="dropdownTestCodeListId" class="UNFAPP-form-fld"
                                (change)="onTestCodeChange($event)">
                                <option value="" disabled selected>Select Test</option>
                            </select>
                        </div>
                    </div>



                    <div class="row" id="dvTestCodeWiseExamResultId">

                        <div class="col-md-12">
                            <div class="report_card">
                                <div class="white_card_header">
                                    <div class="mod_flex">
                                        <div>
                                            <h2 class="main_title">
                                                <span class="neetbg" id="testTypeId6"></span>
                                                <span class="total_marks" id="examTitleNameId"></span>
                                                <span class="total_marks" id="examTotalMarksId"></span>
                                                <span class="time_taken" id="examTimeTakenId"></span>
                                            </h2>
                                        </div>
                                        <!-- <div class="view_btns ans_width">
                                    <a href="#" class="ans_sheet">View answer sheet</a>
                                </div> -->
                                    </div>
                                </div>
                                <div class="white_card_header">
                                    <div class="row">
                                        <div id="examResultsMathsId" class="col-md-3 col-sm-3 col-lg-3">
                                            <div class="sub_marks">
                                                <div class="phybg">
                                                    <div class="subject_flex">
                                                        <div>
                                                            <figure class="mb-0">
                                                                <img src="../../../../assets/image/physics.png"
                                                                    alt="physics" class="sub_rp_img">
                                                            </figure>
                                                        </div>
                                                        <div>
                                                            <h6 class="subject_title">Maths</h6>
                                                            <h4 class="subject_num">
                                                                <span id="mathsMarksId"></span>
                                                                <span id="mathsPercId"></span>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="sub_perform">
                                                <div>
                                                    <p class="rp_tick"><span><img src="../../../../assets/image/tick.png" alt="tick"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_cross"><span><img src="../../../../assets/image/cross.png" alt="cross"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_dot"><span><img src="../../../../assets/image/dot.png" alt="dot"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                            </div> -->
                                                </div>
                                            </div>
                                            <div class="sub_score">
                                                <div class="phybg">
                                                    <div class="scrflex">
                                                        <div class="scrflx_one">
                                                            <h6 class="scr_title">Topper Score</h6>
                                                            <h5 class="scr_numtxt" id="mathsTopperScoreId">-
                                                            </h5>
                                                        </div>
                                                        <div class="scrflx_two">
                                                            <h6 class="scr_title">Average Score</h6>
                                                            <h5 class="scr_numtxt" id="mathsTopperPercId">-</h5>
                                                        </div>
                                                    </div>
                                                    <div class="scrankflex">
                                                        <div class="scrankflx_one">
                                                            <h6 class="scrk_title">Campus Rank</h6>
                                                            <h5 class="scrk_numtxt" id="mathsCampusRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_two">
                                                            <h6 class="scrk_title">State Rank</h6>
                                                            <h5 class="scrk_numtxt" id="mathsStateRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_three">
                                                            <h6 class="scrk_title">AIR</h6>
                                                            <h5 class="scrk_numtxt" id="mathsRankId">-</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="examResultsPhyId" class="col-md-3 col-sm-3 col-lg-3">
                                            <div class="sub_marks">
                                                <div class="phybg">
                                                    <div class="subject_flex">
                                                        <div>
                                                            <figure class="mb-0">
                                                                <img src="../../../../assets/image/physics.png"
                                                                    alt="physics" class="sub_rp_img">
                                                            </figure>
                                                        </div>
                                                        <div>
                                                            <h6 class="subject_title"> Physics</h6>
                                                            <h4 class="subject_num">
                                                                <span id="phyMarksId"></span>
                                                                <span id="phyPercId">()</span>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="sub_perform">
                                                <div>
                                                    <p class="rp_tick"><span><img src="../../../../assets/image/tick.png" alt="tick"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_cross"><span><img src="../../../../assets/image/cross.png" alt="cross"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_dot"><span><img src="../../../../assets/image/dot.png" alt="dot"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                            </div> -->
                                                </div>
                                            </div>
                                            <div class="sub_score">
                                                <div class="phybg">
                                                    <div class="scrflex">
                                                        <div class="scrflx_one">
                                                            <h6 class="scr_title">Topper Score</h6>
                                                            <h5 class="scr_numtxt" id="phyTopperScoreId">-</h5>
                                                        </div>
                                                        <div class="scrflx_two">
                                                            <h6 class="scr_title">Average Score</h6>
                                                            <h5 class="scr_numtxt" id="phyTopperPercId"></h5>
                                                        </div>
                                                    </div>
                                                    <div class="scrankflex">
                                                        <div class="scrankflx_one">
                                                            <h6 class="scrk_title">Campus Rank</h6>
                                                            <h5 class="scrk_numtxt" id="phyCampusRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_two">
                                                            <h6 class="scrk_title">State Rank</h6>
                                                            <h5 class="scrk_numtxt" id="phyStateRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_three">
                                                            <h6 class="scrk_title">AIR</h6>
                                                            <h5 class="scrk_numtxt" id="phyRankId">-</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="examResultsChemId" class="col-md-3 col-sm-3 col-lg-3">
                                            <div class="sub_marks">
                                                <div class="chebg">
                                                    <div class="subject_flex">
                                                        <div>
                                                            <figure class="mb-0">
                                                                <img src="../../../../assets/image/chemistry.png"
                                                                    alt="Chemistry" class="sub_rp_img">
                                                            </figure>
                                                        </div>
                                                        <div>
                                                            <h6 class="subject_title">Chemistry</h6>
                                                            <h4 class="subject_num">
                                                                <span id="chemMarksId"> </span>
                                                                <span id="chemPercId"> </span>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="sub_perform">
                                                <div>
                                                    <p class="rp_tick"><span><img src="../../../../assets/image/tick.png" alt="tick"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_cross"><span><img src="../../../../assets/image/cross.png" alt="cross"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_dot"><span><img src="../../../../assets/image/dot.png" alt="dot"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                            </div> -->
                                                </div>
                                            </div>
                                            <div class="sub_score">
                                                <div class="chebg">
                                                    <div class="scrflex chebrbtm">
                                                        <div class="scrflx_one chebrrgt">
                                                            <h6 class="scr_title">Topper Score</h6>
                                                            <h5 class="scr_numtxt" id="chemTopperScoreId"></h5>
                                                        </div>
                                                        <div class="scrflx_two">
                                                            <h6 class="scr_title">Average Score</h6>
                                                            <h5 class="scr_numtxt" id="chemTopperPercId">-</h5>
                                                        </div>
                                                    </div>
                                                    <div class="scrankflex">
                                                        <div class="scrankflx_one chebrrgt">
                                                            <h6 class="scrk_title">Campus Rank</h6>
                                                            <h5 class="scrk_numtxt" id="chemCampusRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_two chebrrgt">
                                                            <h6 class="scrk_title">State Rank</h6>
                                                            <h5 class="scrk_numtxt" id="chemStateRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_three">
                                                            <h6 class="scrk_title">AIR</h6>
                                                            <h5 class="scrk_numtxt" id="chemRankId">-</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="examResultsBotId" class="col-md-3 col-sm-3 col-lg-3">
                                            <div class="sub_marks">
                                                <div class="botbg">
                                                    <div class="subject_flex">
                                                        <div>
                                                            <figure class="mb-0">
                                                                <img src="../../../../assets/image/botany.png"
                                                                    alt="Botany" class="sub_rp_img">
                                                            </figure>
                                                        </div>
                                                        <div>
                                                            <h6 class="subject_title">Botany</h6>
                                                            <h4 class="subject_num">
                                                                <span id="botMarksId"></span>
                                                                <span id="botPercId"></span>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="sub_perform">
                                                <div>
                                                    <p class="rp_tick"><span><img src="../../../../assets/image/tick.png" alt="tick"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_cross"><span><img src="../../../../assets/image/cross.png" alt="cross"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_dot"><span><img src="../../../../assets/image/dot.png" alt="dot"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                            </div> -->
                                                </div>
                                            </div>
                                            <div class="sub_score">
                                                <div class="botbg">
                                                    <div class="scrflex botbrbtm">
                                                        <div class="scrflx_one botbrrgt">
                                                            <h6 class="scr_title">Topper Score</h6>
                                                            <h5 class="scr_numtxt" id="botTopperScoreId"></h5>
                                                        </div>
                                                        <div class="scrflx_two">
                                                            <h6 class="scr_title">Average Score</h6>
                                                            <h5 class="scr_numtxt" id="botTopperPercId">-</h5>
                                                        </div>
                                                    </div>
                                                    <div class="scrankflex">
                                                        <div class="scrankflx_one botbrrgt">
                                                            <h6 class="scrk_title">Campus Rank</h6>
                                                            <h5 class="scrk_numtxt" id="botCampusRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_two botbrrgt">
                                                            <h6 class="scrk_title">State Rank</h6>
                                                            <h5 class="scrk_numtxt" id="botStateRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_three">
                                                            <h6 class="scrk_title">AIR</h6>
                                                            <h5 class="scrk_numtxt" id="botRankId">-</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="examResultsZooId" class="col-md-3 col-sm-3 col-lg-3">
                                            <div class="sub_marks">
                                                <div class="zoobg">
                                                    <div class="subject_flex">
                                                        <div>
                                                            <figure class="mb-0">
                                                                <img src="../../../../assets/image/zoology.png"
                                                                    alt="Zoology" class="sub_rp_img">
                                                            </figure>
                                                        </div>
                                                        <div>
                                                            <h6 class="subject_title">Zoology</h6>
                                                            <h4 class="subject_num">
                                                                <span id="zooMarksId"></span>
                                                                <span id="zooPercId"></span>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="sub_perform">
                                                <div>
                                                    <p class="rp_tick"><span><img src="../../../../assets/image/tick.png" alt="tick"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_cross"><span><img src="../../../../assets/image/cross.png" alt="cross"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                                <div>
                                                    <p class="rp_dot"><span><img src="../../../../assets/image/dot.png" alt="dot"
                                                                class="mrsign"></span>(-)</p>
                                                </div>
                                            </div> -->
                                                </div>
                                            </div>
                                            <div class="sub_score">
                                                <div class="zoobg">
                                                    <div class="scrflex zoobrbtm">
                                                        <div class="scrflx_one zoobrrgt">
                                                            <h6 class="scr_title">Topper Score</h6>
                                                            <h5 class="scr_numtxt" id="zooTopperScoreId">-</h5>
                                                        </div>
                                                        <div class="scrflx_two">
                                                            <h6 class="scr_title">Average Score</h6>
                                                            <h5 class="scr_numtxt" id="zooTopperPercId">-</h5>
                                                        </div>
                                                    </div>
                                                    <div class="scrankflex">
                                                        <div class="scrankflx_one zoobrrgt">
                                                            <h6 class="scrk_title">Campus Rank</h6>
                                                            <h5 class="scrk_numtxt" id="zooCampusRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_two zoobrrgt">
                                                            <h6 class="scrk_title">State Rank</h6>
                                                            <h5 class="scrk_numtxt" id="zooStateRankId">-</h5>
                                                        </div>
                                                        <div class="scrankflx_three">
                                                            <h6 class="scrk_title">AIR</h6>
                                                            <h5 class="scrk_numtxt" id="zooRankId">-</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- enrollnow form Modal starts-->

            <div class="modal fade bd-example-modal-lg" id="enrollnow" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="nspopup">
                            <button type="button" class="close nsbg-close" data-dismiss="modal"
                                aria-label="Close "><span aria-hidden="true" class="bg-close"
                                    (click)="modelPopupClose()">&times;</span></button>
                        </div>
                        <div class="modal-body" id="element-to-print">
                            <div class="form-style">
                                <div class="row">
                                    <div class="col-md-12">
                                        <figure class="mb-0">
                                  <!-- <img src="../../../../assets/image/srichaitanyalogo.png"  alt="popup" class="popupbanner">  -->
                                     <img id="imgHeaderId"  class="popupbanner">
                                 </figure>
                             </div>
                         </div>
                         <div class="row">
                             <div class="col-md-12 col-lg-12 col-12">
                                 <div class="table-responsive table_font">
                                     <table  width="100%" class="table table-bordered keeptogether myStyle">
                                         <thead>
                                             <tr class="table_hd">
                                                
                                                 <td colspan="3" width="50%"><img src="../../../../assets/image/srichaitanyalogo.png" alt="srichaitanyalogo" class="srichaitanyalogo"></td>
                                                 <th colspan="3" width="50%" class="progress_hd">Progress Report</th>
                                                </tr>
                                             <tr class="table_hd">
                                                 <th class="thd_ctr">Admission No</th>
                                                 <th class="thd_ctr" id="popUpAdmNoId" >-</th>
                                                 <th class="thd_ctr" id="campus" colspan="1">Campus</th>
                                                 <th class="thd_ctr" id="popUpCampusId"  colspan="6">-</th>
                                             </tr>
                                             <tr>
                                                 <th scope="row"  class="table_hd">Name of the Student</th>
                                                 <th  colspan="3" id="popUpStudentNameId"></th>
                                                 <th class="thd_ctr" >Section</th>
                                             </tr>
                                             <tr>
                                                 <th scope="row" class="table_hd">Father Name</th>
                                                 <th  colspan="3" id="popUpFatherNameId"></th>
                                                 <th class="thd_ctr" id="popUpSectionId">-</th>
                                             </tr>
                                         </thead>
                                     </table>
                                 </div>
                             </div>
                         </div>
                         <!-- <div class="html2pdf__page-break"></div> -->
                         <div class="row">
                            <div class="col-md-12 col-lg-12 col-12">
                                <div style="display: none;" id="dvTestWiseMarksId" class="table-responsive table_font">
                                </div>
                            </div>
                            <div   class="col-md-12 col-lg-12 col-12">
                                <div id="dvTestWiseMarksPDFId" class="table-responsive table_font">
                                </div>
                            </div>
                        </div>
                         <div class="row">
                             <div class="col-md-12">
                                 <figure class="mb-0">
                                     <img id="imgFooterId" alt="popup" class="popupbanner">
                                 </figure>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mob_ctr">
                                        <div class="reprt_btnflex">
                                    
                                            <div>
                                                <button type="button" class="dwnld_btn"
                                                    (click)="download()" >Download</button>
                                            </div>
                                            <div>
                                                <button type="button" class="close_btn nsbg-close" data-dismiss="modal"
                                                    aria-label="Close">Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!-- enrollnow form Modal ends-->
        </section>
    </div>
</body>


<!-- ================================ loader ======================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>